export default __webpack_public_path__ + "static/media/AdnanSayed.88f9a47f.jpeg";